/**
 * Validation and presentation helpers for the strike price schedule.
 * No Vue or AngularJS dependency.
 */

import { hasPrice } from './strike-price-week';

/**
 * Parses user-entered text into a strike price.
 * Blank input clears the cell; a leading `$` and thousands separators are tolerated.
 */
export function parsePrice(raw) {
  if (raw === undefined || raw === null) {
    return { ok: true, value: undefined };
  }
  const trimmed = String(raw).trim();
  if (trimmed === '') {
    return { ok: true, value: undefined };
  }
  const text = trimmed.replace(/^\$/, '').replace(/,/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(text)) {
    return { ok: false };
  }
  const value = Number(text);
  if (!(value > 0)) {
    return { ok: false };
  }
  return { ok: true, value };
}

export function priceToColor(price, minPrice, maxPrice) {
  if (!hasPrice(price)) {
    return 'transparent';
  }
  if (minPrice === maxPrice) {
    return 'hsl(210, 60%, 70%)';
  }
  const ratio = (price - minPrice) / (maxPrice - minPrice);
  const hue = 210 - ratio * 180;
  const sat = 50 + ratio * 20;
  return 'hsl(' + hue + ', ' + sat + '%, 65%)';
}
